export default __webpack_public_path__ + "static/media/service-icon-1A.2709247d.png";